import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Constants } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class AprRatesService {
  constants: Constants = new Constants();

  HTTP_CONSTANT_OPTIONS = {
    headers: new HttpHeaders({
		'Content-Type': 'application/json, application/x-www-form-urlencoded;charset=ISO-8859-15',
		'Accept': 'application/json'
    })
  };
  header = new HttpHeaders().set('Content-Type', 'application/json')
  constructor(private readonly http: HttpClient) {
	
   }

  getAPRCostsForFiscalYear(fiscalYear): Observable<any> {
    console.info("Entered getAPRCostsForFiscalYear()");
	return this.http
		.get(this.constants.getApiBasePath() + `/api/v1/getaprcosts?fiscalYear=${fiscalYear}`, this.HTTP_CONSTANT_OPTIONS)
	    .pipe(
			tap(_ => this.log('data success')),
			catchError(this.handleError<any>('data fails'))
		);
  }

  addAprCost(arrData: any): Observable<any> {
    console.info("Entered addAprCost()");
    const headers = this.header
	return this.http
		.post(this.constants.getApiBasePath() + `/api/v1/aprcosts/add`, arrData, { headers, responseType: 'text' })
		.pipe(
			tap(_ => this.log('data inserted success')),
			catchError(this.handleError<any>('data insert failed'))
		);
  }

  deleteAprCost(arrData: any): Observable<any> {
    console.info("Entered deleteAprCost()");
		return this.http
			.delete(this.constants.getApiBasePath() + `/api/v1/aprcosts/delete/${arrData.rateId}`)
			.pipe(
				tap(_ => this.log('data delete success')),
				catchError(this.handleError<any>('data delete failed'))
			);
  }

  editAPRCost(arrData: any): Observable<any> {
    console.info("Entered editAPRCost()");
		const headers = this.header;
		return this.http
			.put(this.constants.getApiBasePath() + `/api/v1/aprcosts/update`, arrData, { headers, responseType: 'text' })
			.pipe(
				tap(_ => this.log('data update success')),
				catchError(this.handleError<any>('data update failed'))
			);
  }

  copyAprCost(arrData: any): Observable<any> {
	console.info("Entered copyAprCost()");
	const headers = this.header;
	
	return this.http
		.post(this.constants.getApiBasePath() + `/api/v1/copyfiscalyear/${arrData.fiscalYear}/copyto/${arrData.newFiscalYear}/copyby/${arrData.userId}`,
			arrData, { headers, responseType: 'text' })
		.pipe(
			tap(_ => this.log('data copy success')),
			catchError(this.handleError1)
		);
  }

  private handleError1(error: HttpErrorResponse) {
		if(error?.status == 409){  // NOSONAR
			return throwError(error.error || "Server Error");
		}else{
			return throwError(error.message || "Server Error");
		}
	}

  private handleError<T>(_operation, result?: T) {
		return (error: any): Observable<T> => {
			console.info(error); // log to console instead
			return of(result as T);
		};
	}

	/** Log a message */
	private log(message: string) {
		console.info('Message: ' + message);
	}
}
